var scope_0 = require('/Users/tim/code/orange-astronaut-website/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/763d272ce309bf733da897f6ae64739b.js').default;
var scope_1 = require('/Users/tim/code/orange-astronaut-website/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/ac105d89d153cbe8557a0ad5743da55a.js').default;export default
        Object.assign({}, scope_0,
scope_1 )
    